import { cn } from "@/lib/utils";
import avatar1 from "@/assets/social-proof/temoignage_3.webp";
import avatar2 from "@/assets/social-proof/temoignage_4.webp";
import avatar3 from "@/assets/social-proof/temoignage_5.webp";
import avatar4 from "@/assets/social-proof/temoignage_6.webp";
import avatar5 from "@/assets/social-proof/temoignage_7.webp";

const avatars = [
  { src: avatar1, alt: "Utilisateur UNOTIF" },
  { src: avatar2, alt: "Utilisateur UNOTIF" },
  { src: avatar3, alt: "Utilisateur UNOTIF" },
  { src: avatar4, alt: "Utilisateur UNOTIF" },
  { src: avatar5, alt: "Utilisateur UNOTIF" },
];

export const SocialProof = () => {
  return (
    <section className="pt-2 pb-0 sm:pt-3 sm:pb-1">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-1.5 sm:gap-4">
        <div className="flex items-center">
          {avatars.map((avatar, i) => (
            <img
              key={i}
              src={avatar.src}
              alt={avatar.alt}
              width={48}
              height={48}
              loading="eager"
              className={cn(
                "w-9 h-9 sm:w-12 sm:h-12 rounded-full border-2 border-[#91d0d8] object-cover",
                "transition-transform duration-300 hover:scale-110 hover:z-10 relative",
                i > 0 && "-ml-2.5 sm:-ml-3"
              )}
            />
          ))}
        </div>
        <div className="flex flex-col text-center sm:text-left">
          <span className="text-[13px] sm:text-[17px] font-semibold text-[#074155] leading-snug">
            utilisé par des indépendants
          </span>
          <span className="text-[11px] sm:text-[14px] font-medium text-muted-foreground leading-snug">
            qui communiquent avec leur audience
          </span>
        </div>
      </div>
    </section>
  );
};
